<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="font-weight-bold">Avaliações</h4>
                        </div>
                    </div>
                    <load mode="table" v-if="loading" />
                    <form v-else @submit.prevent="submit" ref="addItem">
                        <div class="row">
                            <form-calendar
                                v-model="acompanhamento.data_avaliacao"
                                grid="4"
                                label="Data da avaliação"
                                :required="true"
                            />
                            <form-input
                                grid="4"
                                v-model="tecnico"
                                label="Técnico responsável"
                                :disabled="true"
                            />
                            <form-input
                                grid="4"
                                v-model="avaliacao.tempo_em_acompanhamento"
                                label="Meses de acompanhamento"
                                :disabled="true"
                            />
                            <form-select
                                :required="true"
                                :itens="opcao"
                                v-model="
                                    avaliacao.foram_disponibilizada_todas_ofertas
                                "
                                label="Foram efetivamente disponibilizadas para a família/indivíduo todas as ofertas de Assistência Social (em termos de serviços, benefícios, programas e projetos) cuja necessidade havia sido identificada pelo profissional?"
                            />
                            <form-select
                                :required="true"
                                :itens="opcao_atendimento"
                                v-model="
                                    avaliacao.atendimento_efetivo_encaminhamentos
                                "
                                label="Em relação aos encaminhamentos da família/indivíduo para as demais políticas públicas, houve Atendimento efetivo e resolutivo por parte da área que recebeu o(s) encaminhamento(s)?"
                            />
                            <form-select
                                :required="true"
                                :itens="opcao"
                                v-model="avaliacao.reconhecimento_familia"
                                label="A família reconhece o Serviço de Proteção e Atendimento Integral à Família (PAIF) como algo que contribui para a superação ou enfrentamento dos seus problemas e dificuldades e deseja continuar recebendo atenções deste Serviço?
"
                            />
                            <label class="col-12 d-block font-weight-bold mb-2"
                                >Como você classifica os resultados obtidos, até
                                o presente momento, no que se refere à ampliação
                                da capacidade de enfrentamento ou superação das
                                condições de vulnerabilidade e/ou risco social e
                                pessoal por parte da família/indivíduo?
                            </label>
                            <form-toggle
                                v-model="avaliacao.classificacao_resultados_um"
                                label="Houve um agravamento/piora em relação à situação inicial da família/indivíduo"
                            />
                            <form-toggle
                                v-model="
                                    avaliacao.classificacao_resultados_dois
                                "
                                label="A situação atual é equivalente à situação inicial, sem avanços identificáveis"
                            />
                            <form-toggle
                                v-model="
                                    avaliacao.classificacao_resultados_tres
                                "
                                label="Houve avanço/melhora da capacidade de enfrentamento ou de superação dos riscos e vulnerabilidades"
                            />
                            <form-toggle
                                v-model="
                                    avaliacao.classificacao_resultados_quatro
                                "
                                label="Houve significativo avanço/melhora da capacidade de enfrentamento ou de superação dos riscos e vulnerabilidades, justificando-se o desligamento do acompanhamento sistemático, sem prejuízo da eventual permanência da família ou indivíduo em outros programas, projetos, serviços ou benefícios da Assistência Social."
                            />
                            <form-textarea-editor
                                :required="true"
                                class="mt-3"
                                v-model="avaliacao.descricao_resultados"
                                label="Registre, descritivamente, os principais resultados alcançados, bem como fatores que contribuíram ou dificultaram o alcance dos resultados:"
                            />
                        </div>
                        <div class="row px-2 d-flex justify-content-end">
                            <button
                                class="btn btn-success btn-submit"
                                data-style="zoom-in"
                                type="submit"
                            >
                                <i class="mdi mdi-content-save" />
                                {{ $t("Salvar") }}
                            </button>
                        </div>
                    </form>
                </div>
                <ModalProximaAvaliacao
                    :id="acompanhamento.id"
                    @update-data="updateDataAvaliacao"
                />
            </div>
        </div>
    </div>
</template>
<script>
import ModalProximaAvaliacao from "../ModalAgendarAvaliacao.vue";
export default {
    components: { ModalProximaAvaliacao },
    props: ["acompanhamento", "status"],
    data() {
        return {
            page: "avaliacao",
            avaliacao: {
                data_avaliacao: "",
                tempo_em_acompanhamento: "",
                foram_disponibilizada_todas_ofertas: "",
                atendimento_efetivo_encaminhamentos: "",
                reconhecimento_familia: "",
                classificacao_resultados_um: "",
                classificacao_resultados_dois: "",
                classificacao_resultados_tres: "",
                classificacao_resultados_quatro: "",
                descricao_resultados: "",
                paf_id: "",
            },
            loading: false,
            tecnico: "",
            opcao: [
                { id: 1, value: "Sim" },
                { id: 2, value: "Parcialmente" },
                { id: 3, value: "Não" },
            ],
            opcao_atendimento: [
                { id: 1, value: "Sim" },
                { id: 2, value: "Parcialmente" },
                { id: 3, value: "Não" },
                {
                    id: 4,
                    value: "Não se aplica, Pois não houve necessidade de encaminhamentos para outras áreas",
                },
            ],
        };
    },
    mounted() {
        // this.getAvaliacao();
    },
    methods: {
        updateDataAvaliacao(data) {
            this.acompanhamento.data_avaliacao = data;
        },
        // getAvaliacao() {
        //     this.loading = true;
        //     axios
        //         .get(`api/dashboard/avaliacao/get/${this.acompanhamento.id}`)
        //         .then((response) => {
        //             if (response.data != {}) {
        //                 this.avaliacao = response.data;
        //                 this.tecnico = this.avaliacao.user
        //                     ? this.avaliacao.user.name
        //                     : "";
        //             }
        //         })
        //         .finally(() => {
        //             this.loading = false;
        //         });
        // },
        getStatusFinalizado() {
            const result = this.status.filter(
                (status) => status.descricao == "FINALIZADO"
            );
            return result[0].id;
        },
        redirectAcompanhamentos(){
            this.$router.replace({ path: `/dashboard/acompanhamento/edit/${this.acompanhamento.id}`, query: { familia_id: this.acompanhamento.familia_id.id } });
        },
        submit() {
            if (this.acompanhamento.data_avaliacao) {
                this.avaliacao.data_avaliacao =
                    this.acompanhamento.data_avaliacao;
                // if (this.avaliacao.data_avaliacao) {
                // 	this.avaliacao.data_avaliacao = moment(
                // 		this.avaliacao.data_avaliacao,
                // 		"YYYY/MM/DD"
                // 	).format("DD/MM/YYYY");
                // }
            }
            this.avaliacao.paf_id = this.acompanhamento.id;
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post(`api/dashboard/avaliacao/store`, this.avaliacao)
                .then((response) => {
                    this.avaliacao = response.data;
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: "Avaliação criada com sucesso.",
                    });
                })
                .finally(() => {
                    // var status_final = this.getStatusFinalizado();
                    // this.acompanhamento.status = status_final;
                    // this.$emit("save", status_final);
                    // this.getAvaliacao();
                    //this.$bvModal.show("agendar-proxima-avaliacao");
                    this.$emit("atualizarPagina", "historico_avaliacao"); // Define a aba desejad
                });
        },
    },
};
</script>
